import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Card, CardMedia } from '@mui/material'
import React from 'react'
import useModals from 'src/Hooks/useModals'
import { makeStyles } from 'tss-react/mui'
import PowerMeterCover from 'src/Resources/Images/shop/PowerMeterCover.jpg'

const useStyles = makeStyles()(theme => ({
  product: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minWidth: '265px',
    maxWidth: '225px',
    minHeight: '350px',
    flexShrink: 0,
    margin: '12px',
    padding: 0,
    paddingBottom: '12px',
    position: 'relative',
  },
  productImage: {
    margin: 0,
    padding: 0,
    objectFit: 'fill',
    width: '100%',
    maxWidth: '100%',
    height: '220px',
    marginBottom: '12px',
  },
  addButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))

/*
 * This component render a card that shows add power meter card.
 */
const AddPowerMeterCard: React.FC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { openShopPowerMeterModal } = useModals()
  return (
    <Card className={classes.product}>
      <CardMedia className={classes.productImage} component="img" image={PowerMeterCover} alt="Product" />
      <Button
        className={classes.addButton}
        size="large"
        variant="contained"
        onClick={() => {
          openShopPowerMeterModal()
        }}
      >
        {t('shop.additional-component.add-power-meter')}
      </Button>
    </Card>
  )
}
export default AddPowerMeterCard
